import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SettingsService } from 'src/app/services/settings.service';
import { CookiePolicyDialogComponent } from '../cookie/cookie-policy-dialog/cookie-policy-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-legal-links',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './legal-links.component.html',
  styleUrl: './legal-links.component.scss',
})
export class LegalLinksComponent {
  #settingsService = inject(SettingsService);
  #dialog = inject(MatDialog);

  legalLinksSignal = toSignal(this.#settingsService.getPublicUiSettings());

  openCookiePolicy() {
    this.#dialog.open(CookiePolicyDialogComponent);
  }
}